import { Await } from 'react-router-dom'

import { PageNotFoundError } from 'common'

import { useUserIdLoaderData } from './loader'
import PublicProfile from './public-profile'

export default function User() {
  const { userId: deferredUserId } = useUserIdLoaderData()

  return (
    <Await resolve={deferredUserId}>
      {(userId) =>
        userId ? <PublicProfile userId={userId} /> : <PageNotFoundError />
      }
    </Await>
  )
}
